import Auth from "./Auth";

class Payments {
    static getPaymentsList(params = false) {
        var queryString = Object.keys(params)
        .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
        .join('&');
        return Auth.makePrivateGet(`${BASE_URL}api/payments?${queryString}`);
    }

    static sendPaymentLink(payment_id){
        return Auth.makePrivatePostWithStatus(`${BASE_URL}api/payments/${payment_id}/send-link`);
    }

    static downloadAgreementPdf(params = null) {
        return Auth.makePrivateBlobPost(`${BASE_URL}agreement-pdf`, params)
    }
}

export default Payments;